
export class AudioProcessor {

    audio: null;
    active: false;
    index: -1;
    hsl = 0;
    hsl_str = '';
    next_note = null;
    action = null;
    gain_node_left = null;
    gain_node_right = null;
    audio_node = null;
    out_node_left = null;
    out_node_right = null;
    volume = 0;
    volume_left = 0;
    volume_right = 0;

    constructor(ac, index) {
        this.ac = ac;
        this.index = index;

        this.audio = new Audio();
        this.audio.crossOrigin = "anonymous";

        this.gain_node_left = this.ac.createGain();
        this.gain_node_right = this.ac.createGain();

        this.audio_node = this.ac.createMediaElementSource(this.audio);
        this.out_node_left = this.audio_node.connect(this.gain_node_left);
        this.out_node_right = this.audio_node.connect(this.gain_node_right);
    }

    get_active_data() {
        return {
            active: this.active,
            action: this.action,
            index: this.index,
            volume: this.gain_node_left.gain.value,
        }
    }

    queue(next_note) {
        if (!next_note) {
            return;
        }

        this.volume = next_note.volume;
        this.volume_left = next_note.volume_left;
        this.volume_right = next_note.volume_right;

        this.audio.src = next_note.audio_src;
        this.audio.load();
        this.audio.volume = 1;
        this.audio.currentTime = 0;

        this.hsl = next_note.hsl;
        this.hsl_str = next_note.hsl_str;
    }

    play(action) {
        this.action = action;
        this.active = true;

        this.gain_node_left.gain.setTargetAtTime(this.volume_left, 0, 0.005);
        this.gain_node_right.gain.setTargetAtTime(this.volume_right, 0, 0.005);

        this.audio.play();

        if (action.ref.current){
            action.ref.current.set_intensity(this.active)
        }
    }

    finish(next_note) {
        this.queue(next_note);
        this.active = false;
    }

    pause(next_note) {
        if (!this.active) {
            return;
        }

        this.gain_node_left.gain.setTargetAtTime(0, this.audio.currentTime, this.action.decay_left_seconds);
        this.gain_node_right.gain.setTargetAtTime(0, this.audio.currentTime, this.action.decay_right_seconds);

        if (this.action.ref.current) {
            this.action.ref.current.set_intensity(0)
        }

        const that = this;
        setTimeout(function () {
            that.finish(next_note);
        }, this.action.decay)
    }
}

export default AudioProcessor;